import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Login.css";
import {
  Box,
  Button,
  Container,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import { AuthContext } from "../../auth/authContext";
import md5 from "md5";
import Copyright from "../../component/Copyright";

const Login = () => {
  const [isLogin, setIsLogin] = useState(true);
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState("");
  const [name] = useState("");
  const [sale, setSale] = useState("");
  const [abbreviation, setAbbreviation] = useState("");
  const [address, setAddress] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if (authContext && authContext.user) {
      if (authContext.user && authContext.user.needUpdatePassword) {
        navigate("/change-password");
      } else if (authContext.isPurchaser()) {
        navigate("/dashboard/material-price");
      } else {
        navigate("/dashboard/orders");
      }
    }
  }, [authContext, navigate]);

  const toggleForm = () => {
    setIsLogin(!isLogin);
    setError("");
  };

  const handlePasswordChange = (psw, confirm = false) => {
    if (confirm) {
      setConfirmPassword(psw);
    } else {
      setPassword(psw);
    }
    if (confirm && psw !== password) {
      setError("两次密码输入不一致");
      return;
    }
    // 执行密码格式校验
    if (!validatePassword(psw)) {
      setError("密码必须包含至少6位字母和数字的组合");
    } else {
      setError("");
    }
  };

  const validatePassword = (psw) => {
    return /^(?=.*[A-Za-z])(?=.*\d).{6,}$/.test(psw);
  };

  const handleEmailChange = (em) => {
    setEmail(em);
    if (!validateEmail(em)) {
      setError("请输入有效的邮箱地址");
    } else {
      setError("");
    }
  };

  const validateEmail = (em) => {
    return /^\w+([-+.]\w+)*@\w+([-.]\w+)*.\w+([-.]\w+)*$/.test(em);
  };

  const handlePhoneChange = (p) => {
    setPhone(p);
    if (!validatePhone(p)) {
      setError("请输入有效的手机号");
    } else {
      setError("");
    }
  };

  const validatePhone = (p) => {
    return /^(13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/.test(
      p,
    );
  };

  const handleLogin = async (event) => {
    event.preventDefault();
    setError("");
    const encryptedPassword = md5(password);
    try {
      if (authContext) {
        await authContext.login(username, encryptedPassword);
        navigate("/login");
      } else {
        setError("登录失败，请刷新页面重试");
      }
    } catch (e) {
      console.error(e);
      if (e instanceof Error) {
        setError(e.message || "登录请求出错");
      } else {
        setError("登录请求出错");
      }
    }
  };

  const handleRegister = async (event) => {
    event.preventDefault();
    // 检查密码和确认密码是否一致
    if (password !== confirmPassword) {
      setError("密码和确认密码不匹配");
      return;
    }
    if (!validatePassword(password)) {
      setError("密码必须包含至少6位字母和数字的组合");
      return;
    }
    if (!validateEmail(email)) {
      setError("请输入有效的邮箱地址");
      return;
    }
    if (!validatePhone(phone)) {
      setError("请输入有效的手机号");
      return;
    }
    try {
      const encryptedPassword = md5(password);
      if (authContext) {
        await authContext.register(
          username,
          encryptedPassword,
          email,
          phone,
          name,
          abbreviation,
          sale,
          address,
        );
        navigate("/login");
      } else {
        setError("注册失败，请刷新页面重试");
      }
    } catch (e) {
      console.error(e);
      if (e instanceof Error) {
        setError(e.message || "注册请求出错");
      } else {
        setError("注册请求出错");
      }
    }
  };

  return (
    <Container component="main" className="loginContainer">
      <Paper elevation={3} className="loginPaper">
        <Typography component="h1" variant="h5">
          {isLogin ? "登录" : "注册"}
        </Typography>
        <Box
          component="form"
          onSubmit={isLogin ? handleLogin : handleRegister}
          className="loginForm"
        >
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="用户名"
            autoComplete="username"
            autoFocus
            value={username}
            onChange={(e) => setUsername(e.target.value)}
          />
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="电子邮件地址"
              value={email}
              onChange={(e) => handleEmailChange(e.target.value)}
            />
          )}
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="手机号"
              value={phone}
              onChange={(e) => handlePhoneChange(e.target.value)}
            />
          )}
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="简称"
              value={abbreviation}
              onChange={(e) => setAbbreviation(e.target.value)}
            />
          )}
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="商务人员"
              value={sale}
              onChange={(e) => setSale(e.target.value)}
            />
          )}
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              fullWidth
              label="通讯地址"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          )}
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            label="密码"
            autoComplete="password"
            type="password"
            value={password}
            onChange={(e) => handlePasswordChange(e.target.value)}
          />
          {!isLogin && (
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              label="确认密码"
              type="password"
              value={confirmPassword}
              onChange={(e) => handlePasswordChange(e.target.value, true)}
            />
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className="loginButton"
          >
            {isLogin ? "登录" : "注册"}
          </Button>
          {error && <div className="loginError">{error}</div>}
          <Grid container>
            <Grid item xs>
              <Button
                sx={{ textTransform: "none" }}
                onClick={toggleForm}
                disabled
              >
                {/*{isLogin ? '没有账户？注册' : '已有账户？登录'}*/}
                当前不开放注册，请联系商务经理开通账号
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
      <Copyright />
    </Container>
  );
};

export default Login;
